import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LayoutContextType {
  isFullWidth: boolean;
  toggleLayout: () => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const [isFullWidth, setIsFullWidth] = useState(false);

  const toggleLayout = () => {
    setIsFullWidth(prev => !prev);
  };

  return (
    <LayoutContext.Provider value={{ isFullWidth, toggleLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};
